// extracted by mini-css-extract-plugin
export var avatarContainer = "_7d-0";
export var avatarTypingWave = "_7d-i";
export var gray = "_7d-f";
export var green = "_7d-c";
export var icon = "_7d-9";
export var image = "_7d-1";
export var lg = "_7d-6";
export var md = "_7d-5";
export var presenceDot = "_7d-b";
export var red = "_7d-d";
export var sm = "_7d-4";
export var status = "_7d-a";
export var typingDot = "_7d-h";
export var typingPill = "_7d-g";
export var xl = "_7d-7";
export var xs = "_7d-3";
export var xxl = "_7d-8";
export var xxs = "_7d-2";
export var yellow = "_7d-e";